/**
 * @desc 新品下单-修改重新提交审批流
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.PlmSkuNewOrderCreateRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/order/updateAndCommit`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
